// @ts-nocheck
import { plugin } from './plugin';
import * as Plugin_0 from '/builds/oem/oem-fe-work-manager/src/.umi-production/plugin-hz/patch-routes.js';
import * as Plugin_1 from '/builds/oem/oem-fe-work-manager/src/.umi-production/plugin-dva/hz-render-client.js';
import * as Plugin_2 from '/builds/oem/oem-fe-work-manager/src/.umi-production/plugin-dva/hz-dva-immer.js';
import * as Plugin_3 from '/builds/oem/oem-fe-work-manager/src/.umi-production/plugin-dva/runtime.tsx';
import * as Plugin_4 from '/builds/oem/oem-fe-work-manager/src/components/raven';
import * as Plugin_5 from '/builds/oem/oem-fe-work-manager/src/dva';

  plugin.register({
    apply: Plugin_0,
    path: '/builds/oem/oem-fe-work-manager/src/.umi-production/plugin-hz/patch-routes.js',
  });
  plugin.register({
    apply: Plugin_1,
    path: '/builds/oem/oem-fe-work-manager/src/.umi-production/plugin-dva/hz-render-client.js',
  });
  plugin.register({
    apply: Plugin_2,
    path: '/builds/oem/oem-fe-work-manager/src/.umi-production/plugin-dva/hz-dva-immer.js',
  });
  plugin.register({
    apply: Plugin_3,
    path: '/builds/oem/oem-fe-work-manager/src/.umi-production/plugin-dva/runtime.tsx',
  });
  plugin.register({
    apply: Plugin_4,
    path: '/builds/oem/oem-fe-work-manager/src/components/raven',
  });
  plugin.register({
    apply: Plugin_5,
    path: '/builds/oem/oem-fe-work-manager/src/dva',
  });
